import MaterialDetailView from './MaterialDetailView';

const views = {
  MaterialDetailView,
};
export default views;
